<template>
  <div class="kefu-order-evaluation" :class="{ checkapp: platform === 'checkapp' }">
    <div class="title" :class="{'title-animate': !showtitle}">您对本次服务满意吗?</div>
    <section class="comment-section" :class="{'comment-animate': !showtitle}">
      <!-- 三档评价  但使用五星评价的逻辑-->
      <three-evaluation
        :scores="scoreSet"
        :greetings="greetings"
        :platform="platform"
        @refreshSelect="refreshSelect"
        @starClick="starClick"
        @inputBlur="inputBlur"
      ></three-evaluation>
      <!-- 三档评价  但使用五星评价的逻辑-->
    </section>
      <z-button-group>
        <z-button
        :disabled="!canSubmit"
        text="提交评价"
        class="rateHome-btn"
        size="large"
        type="primary"
        @click="submit"
        ></z-button>
      </z-button-group>
  </div>
</template>

<script>
import Vue from 'vue'
import native from '@zz-common/native-adapter'
import { lego } from '@zz-common/lego'
import { getQuestionnaireFormInfo, submitQuestionnaire } from '@api/resourceApi'
import { toast } from '../../native'
import { queryParams } from '../../lib/utils'
import ThreeEvaluation from '../KefuOrderEvaluation/ThreeEvaluation/Evaluation'
import { Button, ButtonGroup } from '@zz-common/zz-ui'
Vue.use(Button).use(ButtonGroup)

const query = queryParams()
export default {
  name: 'KefuOrderEvaluation',
  components: {
    ThreeEvaluation
  },
  data() {
    return {
      recordid: query.recordid || this.$route.query.recordid,
      greetings: '',
      scoreSet: [],
      currScore: {
        score: -1,
        content: '',
        optionIds: ''
      },
      showtitle: true,
      isFocus: false,
      platform: native.client || 'zz' // 获取当前客户端平台，默认为转转
    }
  },
  computed: {
    canSubmit() {
      return this.currScore.score > 0
    }
  },
  methods: {
    inputFocus() {
      this.isFocus = true
    },
    inputBlur() {
      this.isFocus = false
      setTimeout(() => {
        document.body.scrollTop = document.body.scrollHeight
      }, 150)
    },
    refreshSelect(info) {
      this.currScore = Object.assign({}, info)
      console.log('this.currScore')
      console.log(this.currScore)
      console.log(this.currScore)
    },
    starClick(item) {
      this.showtitle = false
      lego.send({
        pagetype: 'ZZUP_KEFUORDER_EVALUATION',
        actiontype: 'STAR_CLICK',
        backup: {
          recordid: this.recordid,
          score: item.score
        }
      })
    },
    checkOpt(item) {
      item.selected = !item.selected
    },
    submit() {
      if (!this.canSubmit) return
      if (this.currScore.content.length > 200) {
        toast({
          msg: '不能超过200字',
          style: '2'
        })
        return
      }
      lego.send({
        pagetype: 'ZZUP_KEFUORDER_EVALUATION',
        actiontype: 'SUBMIT_CLICK',
        backup: {
          recordid: this.recordid,
          score: this.currScore.score,
          hascomment: Boolean(this.currScore.content)
        }
      })

      submitQuestionnaire({
        recordId: this.recordid,
        score: this.currScore.score,
        content: this.currScore.content,
        optionIds: this.currScore.optionIds
      })
        .then((data) => {
          if (Number(data.status) === 1000) {
            native.skipToUrl({
              targetUrl:
                  'https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/orderevaluation/success',
              needClose: '1'
            })
          } else {
            toast({
              msg: data.msg || '提交失败',
              style: '2'
            })
          }
        })
        .catch((err) => {
          console.error(err)
          toast({
            msg: err.errMsg || err,
            style: '2'
          })
        })
    }
  },
  mounted() {
    native.setTitle({
      title: '服务反馈评价'
    })

    lego.send({
      pagetype: 'ZZUP_KEFUORDER_EVALUATION',
      actiontype: 'PAGE_SHOW',
      backup: {
        recordid: this.recordid
      }
    })

    getQuestionnaireFormInfo({
      recordId: this.recordid
    })
      .then((data) => {
        this.greetings = data.desc
        this.scoreSet = data.scores
      })
      .catch((err) => {
        console.error(err)
        toast({
          msg: err.errMsg || err,
          style: '2'
        })
      })
  }
}
</script>

<style scoped lang="less">
  @import 'KefuOrderEvaluation.less';
</style>
